// Currently supported sort orders in eSTORIS.
const DEFAULT = 0;
const ATOZ = 5;
const ZTOA = 6;
const LOWTOHIGH = 10;
const HIGHTOLOW = 11;
const NEWEST = 15;

/**
 * Hold the current product filters selected by the user.
 */
class ProductFilters {
	constructor() {
		this.categoryId = undefined;
		this.loadFilterableOptions = false;
		this._limit = 16;
		this._minPrice = 0;
		this._maxPrice = undefined;
		this._orderBy = DEFAULT;
		this._page = 0;
		this._term = '';
		this._onDisplay = false;
		this._inStockOnly = false;
		this.specAttributes = [];
	}

	// number of results per page
	get limit() {
		return this._limit;
	}

	set limit(value) {
		if (typeof value !== 'number' || value < 0) {
			throw new TypeError('Limit must be a positive number');
		}

		this._limit = value;
	}

	get minPrice() {
		return this._minPrice;
	}

	set minPrice(value) {
		if (typeof value !== 'number' || value < 0) {
			throw new TypeError('Minimum must be a zero or greater');
		}

		this._minPrice = value;
	}

	get maxPrice() {
		return this._maxPrice;
	}

	set maxPrice(value) {
		if ((typeof value !== 'number' || value < 0) && typeof value !== 'undefined') {
			throw new TypeError('Maximum must be a positive number');
		}

		this._maxPrice = value;
	}

	get orderBy() {
		return this._orderBy;
	}

	set orderBy(value) {
		switch (value) {
			case DEFAULT:
				break;
			case ATOZ:
				break;
			case ZTOA:
				break;
			case LOWTOHIGH:
				break;
			case HIGHTOLOW:
				break;
			case NEWEST:
				break;
			default:
				throw new TypeError('Invalid sort type');
		}

		this._orderBy = value;
	}

	get page() {
		return this._page;
	}

	set page(value) {
		if (typeof value !== 'number' || value < 0) {
			throw new TypeError('Page must be zero or greater');
		}

		this._page = value;
	}

	get term() {
		return this._term;
	}

	set term(value) {
		if (typeof value !== 'string') {
			throw new TypeError('Search term must be a string');
		}

		this._term = value;
	}

	get onDisplay() {
		return this._onDisplay;
	}

	set onDisplay(value) {
		if (typeof value !== 'boolean') {
			throw new TypeError('On Display must be boolean');
		}

		this._onDisplay = value;
	}

	get inStockOnly() {
		return this._inStockOnly;
	}

	set inStockOnly(value) {
		if (typeof value !== 'boolean') {
			throw new TypeError('In Stock must be boolean');
		}

		this._inStockOnly = value;
	}
}

export { DEFAULT, ATOZ, ZTOA, LOWTOHIGH, HIGHTOLOW, NEWEST };

export default ProductFilters;
